import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseBillingBillsProps<T> = {
  filters?: {
    page?: number;
    status?: string;
    startDate?: string;
    endDate?: string;
    branchId?: string
    showDescendants?: boolean
  };
  mapper?: (data: any) => T,
};

export const useBillingBills = <T,>({
  filters: {
    page,
    status,
    startDate,
    endDate,
    branchId,
    showDescendants
  } = {},
  mapper = Mapper.default<T>(),
}: UseBillingBillsProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: [
      'billingEvents',
      page,
      status,
      startDate,
      endDate,
      branchId,
      showDescendants
    ],
    queryFn: () => {
      return privateAxios.get('/billing/bills', {
        params: {
          page,
          'q[status_eq]': status,
          'q[opened_at_gteq]': startDate,
          'q[closed_at_lteq]': endDate,
          'q[branch_id_eq]': branchId,
          'q[show_from_descendants]': showDescendants,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
